import { Code02Icon } from '@/assets/icons';
import { BaseModal } from '@/components/common';

interface IProcessingLogDialog {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  message: string;
}

export const ProcessingLogDialog = ({
  open,
  onOpenChange,
  title,
  message,
}: IProcessingLogDialog) => {
  return (
    <BaseModal
      hideFooter
      open={open}
      onOpen={onOpenChange}
      title={
        <div className="flex flex-row justify-start items-center gap-2">
          <Code02Icon className="size-5 text-neutral-9" />
          <span className="text-body-base font-semibold text-neutral-9">{title}</span>
        </div>
      }
      contentClassName="rounded-[12px] !p-3 max-w-[560px]"
    >
      <div className="overflow-auto rounded-xs p-3 bg-neutral-1 border border-neutral-4 text-body-sm font-medium text-neutral-7 max-h-[50vh] break-words">
        {message}
      </div>
    </BaseModal>
  );
};
